import repeatDataHandler from './repeat_data_handler.vue'
import { createCmpEngine } from '@/utils'

export const openRepeatDataHandler = createCmpEngine(repeatDataHandler)
